import { useEmitter } from '@/utils/emitter';

export function useEventMixin() {
  const emitter = useEmitter();

  const editEventHandler = (eventName, eventParams) => {
    emitter.dispatch('SettingPanel', 'editEventHandler', [eventName, [...eventParams]]);
  };

  return {
    editEventHandler,
  };
}
